import { combineReducers } from '@reduxjs/toolkit';
import modulesReducer from '../feature/modules/moduleSlice'
import daycareReducer from "../feature/dayCare/dayCareSlice"
import subscriptionReducer from "../feature/subscription/subscriptionSlice"
import enquiryReducer from '../feature/enquiry/enquirySlice'
import relationTypeReducer from '../feature/relation/RelationTypeSlice'
import categoryReducer from "../feature/category/CategorySlice"
import privacyReducer from "../feature/cms/PrivacySlice"
import termReducer from "../feature/cms/TermSlice"
import aboutReducer from "../feature/cms/AboutSlice"
import dashboardReducer from "../feature/dashboard/DashboardSlice"
import paymentReducer from "../feature/dayCare/paymentHistorySlice"

const rootReducer = combineReducers({
  modules: modulesReducer,
  daycares: daycareReducer,
  subscriptions: subscriptionReducer,
  enquiries: enquiryReducer,
  relations: relationTypeReducer,
  categories: categoryReducer,
  privacies: privacyReducer,
  terms: termReducer,
  abouts: aboutReducer,
  dashboards: dashboardReducer,
  payments: paymentReducer,
});

export default rootReducer;
